var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tinted-image", class: [_vm.bemFacet] }, [
    _c(
      "button",
      {
        staticClass: "tinted-image--button",
        attrs: { disabled: _vm.isInert ? true : null },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.onSelectedHandler()
          }
        }
      },
      [
        _c("img", {
          staticClass: "tinted-image--img tinted-image--img__fallback",
          attrs: { src: _vm.img.url }
        }),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "tinted-image--thumb",
            attrs: {
              width: "16",
              height: "9",
              viewBox: "0 0 16 9",
              version: "1.1",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              xmlns: "http://www.w3.org/2000/svg",
              role: "img",
              "aria-label": _vm.img.alt
            }
          },
          [
            _c("image", {
              staticClass: "tinted-image--img tinted-image--img__bw",
              attrs: {
                "xlink:href": _vm.img.url,
                filter: "url(#svg-filter-source-grayscale)",
                width: "100%",
                height: "100%"
              }
            }),
            _vm._v(" "),
            _c("image", {
              staticClass: "tinted-image--img tinted-image--img__color",
              attrs: {
                "xlink:href": _vm.img.url,
                width: "100%",
                height: "100%"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54b699d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b699d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/tinted-image/index.vue
// module id = 423
// module chunks = 5